import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

export interface ISettingStateSlice {
  notifications: INotificationSettings | null;
  notificationState: IReduxLoadingState;
  localBetaFeature: boolean;
  editInfoSelectedPCNotification?: BEAPerPatientSetting | null;
  /**
   * User-customized mobile bottom-nav order. An ordered list of route keys
   * the user has pinned to the bottom bar. `null` means "use the default set"
   * (no customization yet). Persisted so the layout survives reloads.
   */
  bottomNavKeys: string[] | null;
}

const name = "notification";

export const initialState: ISettingStateSlice = {
  notifications: null,
  notificationState: "pending",
  localBetaFeature: true,
  editInfoSelectedPCNotification: null,
  bottomNavKeys: null,
};

export const settingSlice = createSlice({
  name,
  initialState,
  reducers: {
    setNotificationSettings(
      state,
      action: PayloadAction<INotificationSettings>
    ) {
      state.notifications = action.payload;
    },
    setEditInfoSelectedPCNotification(
      state,
      action: PayloadAction<BEAPerPatientSetting | null>
    ) {
      state.editInfoSelectedPCNotification = action.payload;
    },
    setLocalBetaFeature(state, action: PayloadAction<boolean>) {
      state.localBetaFeature = action.payload;
    },
    setBottomNavKeys(state, action: PayloadAction<string[] | null>) {
      state.bottomNavKeys = action.payload;
    },
  },
});

export const {
  setNotificationSettings,
  setLocalBetaFeature,
  setEditInfoSelectedPCNotification,
  setBottomNavKeys,
} = settingSlice.actions;

const persistedReducer = persistReducer(
  {
    key: name,
    storage: storage,
    whitelist: [
      "localBetaFeature",
      "editInfoSelectedPCNotification",
      "bottomNavKeys",
    ],
  },
  settingSlice.reducer
);

export default persistedReducer;
